import { render, staticRenderFns } from "./GamesPage.vue?vue&type=template&id=b4dfaef0&scoped=true&"
import script from "./GamesPage.vue?vue&type=script&lang=ts&"
export * from "./GamesPage.vue?vue&type=script&lang=ts&"
import style0 from "./GamesPage.vue?vue&type=style&index=0&id=b4dfaef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dfaef0",
  null
  
)

export default component.exports